var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let mockUser = {
    UserId: "f4519f848aab479e8bb9dd7c8506e86a",
    UserName: "预览用户",
    LastLoginTime: 1665970625290,
    LoginCount: 2,
    Status: "normal",
    CreateTime: 1665629607385,
    UpdateTime: 1665970625290,
    Source: "Normal",
    Env: "dev",
    ThirdUserId: "",
};
export const createMockServiceByData = (api, data, allLogics = {}) => {
    var _a;
    if (api === "GetUser") {
        data = { Data: mockUser };
    }
    else if (api === "GetUserResources") {
        let roles = JSON.parse((_a = window === null || window === void 0 ? void 0 : window.allMockData) === null || _a === void 0 ? void 0 : _a.roles);
        let currRole = (roles === null || roles === void 0 ? void 0 : roles.currentRole) || "DEV-AdminRole";
        let PList = roles.roleResourceMappingList || [
            { resourceType: "ui", resourcePath: "/permission_center/resourceManagement", roleName: "DEV-AdminRole" },
            { resourceType: "ui", resourcePath: "/permission_center/addRoleUser", roleName: "DEV-AdminRole" },
            { resourceType: "ui", resourcePath: "/permission_center/roleManagement", roleName: "DEV-AdminRole" },
            { resourceType: "ui", resourcePath: "/permission_center/userManagement", roleName: "DEV-AdminRole" },
            { resourceType: "ui", resourcePath: "/permission_center", roleName: "DEV-AdminRole" },
        ];
        data = PList.filter((it) => it.roleName === currRole).map((it) => {
            return {
                resourceValue: it.resourcePath,
                resourceType: "ui",
            };
        });
    }
    function mockRequest(...args) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log("请求了mock接口: ", api, args, data);
            return Promise.resolve(data);
        });
    }
    !allLogics[api] && (allLogics[api] = mockRequest);
    return allLogics;
};
